import { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";

const PreferenciasPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])

  const eliminarItem = (id) => {
    setIsLoading(true);
    try {
      fetch("/p_preferencia",{
        method: "DELETE",
        headers:{
          "Content-Type": "application/json",
        },
        body: JSON.stringify({id})
      })
      .then((res) => res.json())
      .then((data) => {
        setDatos([])
        cargarDatos();
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const [datosTabla] = useState({
    titulo: "Preferencias",
    ruta: "/preferencia",
    esAgregar: true,
    esEditar: true,
    esEliminar: true,
    eliminar: eliminarItem,
    configTable: configTable,
    keySucursal: "ID_SUC_PRS"
  })

  const [cabecera] = useState([
    { title: "ID", key: "ID_PRE" },
    { title: "NOMBRE", key: "NOMBRE_PRE" },
    { title: "SUCURSAL", key: "NOMBRE_SUCURSAL_SUC" },
    { title: "FECHA ALTA", key: "FECHA_ALTA_PRE", isDate: true },
  ]);

  const cargarDatos = async () => {
    try {
      fetch("/p_preferencias",{
        method: "GET",
        headers:{
          "Content-Type": "application/json",
        }
      })
      .then((res) => res.json())
      .then((data) => {
        if(data.status === 1){
          setDatos(data.data);
        }
        setIsLoading(false);
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/> }
      </MasterLayout>
    </>
  );
};

export default PreferenciasPage;